import {Component, OnInit} from '@angular/core';
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {Utils} from "../../../utils/utils";
import {first} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {combineLatest} from "rxjs";
import {UserSubscription} from "../../../../user/user-subscription";

@Component({
    selector: 'db-migration-dialog',
    templateUrl: './migration-dialog.component.html',
    styleUrls: ['./migration-dialog.component.scss'],
    standalone: false
})
export class MigrationDialogComponent extends DialogComponent<any, any> implements OnInit {
  public hostedWebsitesLimit: any;
  public hostedWebsitesCount: any;
  public isMobile: boolean = false;
  public currentSubscription: UserSubscription;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super (
      _dialogService
    );
  }

  ngOnInit() {
    this._getWebsitesCount();
    if ((Utils.checkDevice() && window.innerWidth <= 1024)) {
      this.isMobile = true;
    }
  }

  private _getWebsitesCount(): void {
    combineLatest(
      this._store.select(fromStore.getWebsites),
      this._store.select(fromStore.getUser),
      this._store.select(fromStore.getUserSubscription),
    )
      .pipe(
        first(([websites, user, userSubscription]) => !!websites && !!user && !!userSubscription)
      )
      .subscribe(([websites, user, userSubscription]) => {
        this.hostedWebsitesCount = websites.filter(website => !website.parentId && website.isActive && website.type === 'live' && !!website.domain_hash).length;
       this.currentSubscription = userSubscription;
        this.hostedWebsitesLimit = user && user.hosting_services && user.hosting_services.domain_count
        && userSubscription && userSubscription.plan ? parseInt(user.hosting_services.domain_count.parameter_value, 10) + user.additionalWebsiteCount : null;

      });
  }
}
